import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vant from 'vant'
import 'vant/lib/index.css'
import VueLuckyCanvas from '@lucky-canvas/vue'
import { registerServiceWorker } from '@/utils/registerServiceWorker'
import { consumeTokenFromUrl } from '@/utils/tokenLogin'
import { getToken, removeUserInfo } from '@/utils/auth'

async function initApp() {
   const usedAdminLoginLink = consumeTokenFromUrl()
   const token = getToken()

   if (token) {
     store.commit('user/SET_TOKEN', token)
     if (usedAdminLoginLink) {
       removeUserInfo()
       store.commit('user/SET_USER_INFO', null)
     }
   }

   const app = createApp(App)

   try {
      // 注册插件
      app.use(router)
         .use(store)
         .use(vant)
         .use(VueLuckyCanvas)

      // 挂载应用
      app.mount('#app')

      // 先用缓存启动，再后台拉新比对是否需要更新
      store.dispatch('config/bootstrapWebViewConfig')

      registerServiceWorker()
   } catch (error) {
      console.error('应用初始化失败:', error)
      // 可以在这里添加错误处理逻辑
   }
}

// 启动应用
initApp()